__webpack_require__.p = "//storage.googleapis.com/cancell-django-static-file/static/";